import { removeToken } from '@/services/passport/passport.service'
import { selectUser } from '@/store/user/user.slice'
import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu } from 'antd'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import OrbitAvatar from '../OrbitAvatar'

export default memo(function UserAction() {
  const userInfo = useSelector(selectUser).userInfo
  const navigate = useNavigate()

  const logout = () => {
    removeToken()
    navigate('/entrance/login')
  }

  const menu = (
    <Menu>
      <Menu.Item key='profile'>
        <Link to={'/home'}>Home</Link>
      </Menu.Item>
      <Menu.Item key={'settings'}>
        <Link to={'/settings'}>Settings</Link>
      </Menu.Item>
      <Menu.Item key={'logout'} onClick={logout}>
        Logout
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <OrbitAvatar avatar={userInfo?.avatar!} name={userInfo?.fullName} size={32} />
      <Dropdown overlay={menu} className={'ml-1'}>
        <span style={{color: '#fff'}}>
          {userInfo?.fullName} <DownOutlined />
        </span>
      </Dropdown>
    </>
  )
})
